import styled from 'styled-components/macro'

const ProductName = styled.h1`
  font-family: inherit;
  font-weight: bold;
  font-size: 32px;
  flex-grow: 1;
`

const Price = styled.p`
  font-size: 40px;
  font-weight: bold;
  padding: 20px 0;
`

export { ProductName, Price }
